export default {
  type: 'document',
  name: 'restrictedVersionActionsTest',
  title: 'Restricted version actions',
  fields: [
    {
      type: 'string',
      name: 'title',
      title: 'Title',
    },
  ],
}
